import { defaultFill } from '../../../utils/constants';
var muiPlayFill16 = {
    paths: [
        {
            path: 'M1.70767228,0.24715116 C1.32262865,-0.0819395244 0.686389699,-0.0838820397 0.295371253,0.250315219 C0.0894601645,0.426304158 -0.00847621939,0.657418255 0.00057412286,0.885418292 C0.00882990534,1.09340144 0.00144064704,10.9252269 0.00250539975,11.1450826 C0.00356052355,11.36295 0.100750071,11.5812112 0.295371253,11.7475509 C0.689115807,12.0840781 1.31869841,12.0831647 1.70767228,11.7507149 L9.30700989,7.05476975 C10.2497097,6.4722365 10.2523497,5.52922023 9.30700989,4.94483885 L1.70767228,0.24715116 Z',
            fill: defaultFill,
        },
    ],
    title: 'Play',
    width: 10,
    height: 12,
};
var muiPlayFill = {
    base: muiPlayFill16,
    smIcon: muiPlayFill16,
};
export { muiPlayFill };
//# sourceMappingURL=playFill.js.map